import { render, staticRenderFns } from "./goods3dh5setting.vue?vue&type=template&id=6bdf5b28&scoped=true"
import script from "./goods3dh5setting.vue?vue&type=script&lang=js"
export * from "./goods3dh5setting.vue?vue&type=script&lang=js"
import style0 from "./goods3dh5setting.vue?vue&type=style&index=0&id=6bdf5b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdf5b28",
  null
  
)

export default component.exports